<div class="rd-widget rd-widget-no-height-restriction lease-expiration-widget widget-{{widgetConfig.widgetId}}" *ngIf="mockupData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="30" class="widget-grid-column lease-expiration-widget-header-red" style="text-align: start;">
            <widget-value class="contract-summary-widget-header" [align]="'left'" [color]="'white'" [bold]="true">{{'directCapLeaseExpiration.labelTitle' | rdTranslate}}</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="top-row">
          <td colspan="6" class="darkGreyTableHeader"><label style="color: white; text-align: left;">{{'directCapLeaseExpiration.usLeaseExpirationsYearEnding' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-right"><label class="header-label">{{'directCapLeaseExpiration.usLeaseExpirationsSfOrAreaExpiring' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-right"><label class="header-label">{{'directCapLeaseExpiration.usLeaseExpirationsPercentOfTotal1' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-right"><label class="header-label">{{'directCapLeaseExpiration.usLeaseExpirationsCumulative' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-right"><label class="header-label">{{'directCapLeaseExpiration.usLeaseExpirationsPercentOfTotal2' | rdTranslate}}</label></td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="i + 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 === 0)}">
            <td colspan="6"><widget-value [align]="'left'"><label>{{ entry.usLeaseExpirationsYearEnding | rdLocalizedDate }}</label></widget-value></td>
            <td colspan="6"><widget-value [align]="'right'"><label>{{ entry.usLeaseExpirationsSfOrAreaExpiring | rdLocalizedNumber }}</label></widget-value></td>
            <td colspan="6"><widget-value [align]="'right'"><label>{{ entry.usLeaseExpirationsPercentOfTotal1 * 100 | rdLocalizedNumber }}%</label></widget-value></td>
            <td colspan="6"><widget-value [align]="'right'"><label>{{ entry.usLeaseExpirationsCumulative | rdLocalizedNumber }}</label></widget-value></td>
            <td colspan="6"><widget-value [align]="'right'"><label>{{ entry.usLeaseExpirationsPercentOfTotal2 * 100 | rdLocalizedNumber }}%</label></widget-value></td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </tbody>
  </table>
</div>
